import { render, staticRenderFns } from "./CampoDataHoraOld.vue?vue&type=template&id=b255c10a"
import script from "./CampoDataHoraOld.vue?vue&type=script&lang=js"
export * from "./CampoDataHoraOld.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports